import { render, staticRenderFns } from "./CheckoutVtexConfirmation.vue?vue&type=template&id=10aaa537&scoped=true"
import script from "./CheckoutVtexConfirmation.vue?vue&type=script&lang=js"
export * from "./CheckoutVtexConfirmation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutVtexConfirmation.vue?vue&type=style&index=0&id=10aaa537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaa537",
  null
  
)

export default component.exports